export var frames = [
    {
        id: 'default',
        title: { en: 'Default Frame', cs: 'Výchozí rám' },
        component: { type: "Widgets_TimeSmall", properties: {} },
    },
    {
        id: 'monitoring',
        title: { en: 'Monitoring', cs: 'Monitoring' },
        component: { type: "Widgets_MonitoringFull", properties: {} },
    },
    {
        id: 'weather',
        title: { en: 'Weather', cs: 'Počasí' },
        component: { type: "Widgets_WeatherFull", properties: {} },
    },
    {
        id: 'time',
        title: { en: 'Time', cs: 'Čas' },
        component: { type: "Widgets_TimeFrame", properties: {} },
    },
];
